/**
 * Parses an ISO 8601 duration string and returns the duration in different units
 * @param {string} duration - ISO 8601 duration string (e.g., 'PT5M', 'PT2H', 'PT1H30M')
 * @returns {Object} Object with hours and minutes properties
 */
export function parseDuration(duration) {
  if (!duration || typeof duration !== 'string') {
    return {hours: 0, minutes: 0};
  }

  // ISO 8601 duration format: P[n]Y[n]M[n]DT[n]H[n]M[n]S
  const regex = /PT(?:(\d+)H)?(?:(\d+)M)?/;
  const match = regex.exec(duration);

  if (!match) {
    return {hours: 0, minutes: 0};
  }

  const hours = Number.parseInt(match[1] || '0', 10);
  const minutes = Number.parseInt(match[2] || '0', 10);

  return {hours, minutes};
}

/**
 * Formats a decimal number of hours as an ISO 8601 duration string
 * @param {number} hours - duration in hours, may include a half-hour fraction
 * @returns {string} ISO 8601 duration string
 */
export function formatDurationFromHours(hours) {
  const totalMinutes = Math.round(hours * 60);
  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const hoursPart = wholeHours ? `${wholeHours}H` : '';
  const minutesPart = minutes ? `${minutes}M` : '';

  return `PT${hoursPart}${minutesPart}`;
}
